import React from 'react';
import { MemberChangeRequestEntity } from '../../models';
import { ChangeRequestContextType } from '../../types';

type MemberChangeRequestContextType = ChangeRequestContextType<MemberChangeRequestEntity>;

export const MemberChangeRequestContext = React.createContext<MemberChangeRequestContextType>(
  {} as MemberChangeRequestContextType,
);
